(function () {
  var FS   = "https://www.gstatic.com/firebasejs/10.8.0/firebase-firestore.js";
  var MAKS = 400;  /* hentes pr. søgning — over dette skal du bruge Typesense */
  var SIDE = 30;   /* varer pr. "Vis flere" */
  /* Vises i feltet, når man ikke har skrevet noget. Ordene skal findes
     i varernes tokens — prøv dem i søgefeltet, før du sætter nye ind. */
  var FORSLAG = ['sofa', 'loungemøbler', 'computer', 'tv', 'seng',
                 'madras', 'spisebord', 'kaffemaskine'];
  var HISTORIK_N = 5;                     /* antal gemte søgninger */
  var HISTORIK_KEY = 'mc_soeg_historik';
  /* Vises før brugeren har søgt. Ordet skal findes i varernes tokens —
     prøv det i søgefeltet først, hvis du skifter det ud. */
  var START_ORD = 'airfryer';
  var VIS_MAKS = 8;  /* rækker pr. gruppe før "vis alle" */
  var STANDARD_ANTAL = 12;  /* antal butikker vist som standard, før man har søgt */

  /* Farver findes ikke som eget felt i varerne — de ligger i tokens
     sammen med alle andre ord. Vi leder derfor efter kendte farveord.
     Listen kan udvides; ord der ikke findes i resultatet, vises ikke. */
  var FARVER = ['sort','hvid','grå','beige','brun','blå','navy','turkis','grøn','rød',
                'bordeaux','rosa','lyserød','pink','lilla','gul','orange','guld','sølv','creme','natur'];

  var qEl   = document.getElementById('mc-s-q');
  var clrEl = document.getElementById('mc-s-clear');
  var goEl  = document.getElementById('mc-s-go');
  var srtEl = document.getElementById('mc-s-sort');
  if (srtEl) srtEl.value = 'cashback';
  var grid  = document.getElementById('mc-s-grid');
  var cntEl = document.getElementById('mc-s-count');
  var msgEl = document.getElementById('mc-s-msg');
  var morW  = document.getElementById('mc-s-more-wrap');
  var morEl = document.getElementById('mc-s-more');
  var dscEl = document.getElementById('mc-s-disc');
  var autoEl = document.getElementById('mc-s-auto');
  var fBtn  = document.getElementById('mc-s-fbtn');
  var fNum  = document.getElementById('mc-s-fnum');
  var fPan  = document.getElementById('mc-s-fpanel');
  var vElm  = document.getElementById('mc-s-valgte');
  var skygge = document.getElementById('mc-s-skygge');
  var logEl  = document.getElementById('mc-s-login');
  if (!grid) return;

  /* fundne  = alt søgningen hentede
     synlige = det der er tilbage efter filtrene. Kortene tegnes altid
               fra synlige, og data-i peger ind i den — ikke i fundne. */
  var fundne = [], synlige = [], vist = SIDE, henter = false, sidsteOrd = '';
  var erForside = true;  /* sandt indtil brugeren har søgt */
  var udvidet = {};  /* grupper hvor "vis alle" er trykket */

  var filtre = {
    butik: [], maerke: [], farve: [], cashback: [],
    minPris: null, maxPris: null, kunTilbud: false
  };

  var ESC = { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' };
  function esc(v){ return String(v==null?'':v).replace(/[&<>"']/g,function(c){return ESC[c];}); }

  /* Samme normalisering som ved import — ellers matcher ordene ikke.
     æøå bevares, fordi de står som de er i tokens. */
  function norm(s){
    return String(s||'').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'')
      .replace(/[^\wæøå\s-]/g,' ').replace(/\s+/g,' ').trim();
  }

  /* ---------- Cashbacksatser pr. butik ----------
     Varen kender sin butik, men ikke satsen — den står som metafelt i
     Shopify. Vi henter den én gang pr. butik og husker den. */
  var satser = {};
  async function hentSats(handle){
    if (satser[handle] !== undefined) return satser[handle];
    satser[handle] = null;
    try {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '?view=cashback');
      if (r.ok) {
        var cb = JSON.parse((await r.text()).trim());
        if (cb) {
          /* Skabelonen svarer med satsen som én tekst, fx "3%" eller
             "50 kr". Vi læser tallet ud og afgør på enheden, om det er
             procent eller et fast beløb — "41 kr" må aldrig blive 41 %. */
          var raa = String(cb.cashback || cb.pct || cb.fast || '');
          var tal = parseFloat(raa.replace(',', '.').replace(/[^0-9.]/g, ''));
          if (!isNaN(tal) && tal > 0) {
            var erKroner = /kr|dkk|,-/i.test(raa);
            satser[handle] = erKroner ? { pct: 0, fast: tal } : { pct: tal, fast: 0 };
          }
        }
      }
    } catch (e) {}
    return satser[handle];
  }

  function cashbackAf(p){
    var s = satser[p.shopHandle];
    if (!s) return null;
    if (s.fast > 0) return Math.round(s.fast);
    if (s.pct > 0 && p.pris > 0) return Math.round(p.pris * s.pct / 100);
    return null;
  }

  /* Læser et resultatsæt fra Firestore. Er ord givet, skal alle ordene
     findes i varens tokens — det er den del af søgningen, Firestore
     ikke selv kan klare. Uden ord tages alt med. */
  function laesSnap(snap, ord){
    var raa = [];
    snap.forEach(function(d){
      var x = d.data(); x.id = d.id;
      x.pris = Number(x.price) || 0;
      x.foer = Number(x.oldPrice) || 0;
      x.rabat = (x.foer > x.pris && x.pris > 0) ? Math.round((1 - x.pris / x.foer) * 100) : 0;
      if (ord && ord.length) {
        var t = x.tokens || [];
        for (var i = 0; i < ord.length; i++) { if (t.indexOf(ord[i]) === -1) return; }
      }
      if (x.pris > 0 && x.image && x.deeplink) raa.push(x);
    });
    return raa;
  }

  /* Satserne hentes for alle butikker i resultatet, ikke kun dem på
     skærmen. Med et par snese butikker er det hurtigt nok, og så
     står der aldrig et kort uden beløb. */
  async function hentAlleSatser(){
    var butikker = [...new Set(fundne.map(function(p){ return p.shopHandle; }))];
    await Promise.all(butikker.map(hentSats));
  }

  /* ---------- Forsidens udvalg ----------
     Uden en søgning skal der stadig stå varer på siden. Vi kører samme
     forespørgsel som en almindelig søgning, bare med START_ORD, og
     sorterer gitteret med højeste pris først. Søgefeltet forbliver
     tomt — ordet står i tælleren i stedet, så det er tydeligt hvad
     man kigger på, uden at feltet ser brugt ud. */
  async function hentForside(){
    if (!window.firebaseDb) return;
    /* Ordet skrives i feltet, så det er tydeligt hvad der søges på —
       og så man kan rette det uden at gætte. Krydset rydder feltet og
       viser den tomme starttilstand, ikke udvalget igen. */
    qEl.value = START_ORD;
    clrEl.classList.add('vis');
    await soeg(START_ORD, true);
  }

  /* ---------- Hent fra Firestore ----------
     Det længste ord bruges som opslag, fordi det giver færrest træf.
     Resten filtreres i browseren — så slipper vi for et sammensat
     index for hver tænkelig ordkombination. */
  async function soeg(tekst, erStart){
    var ord = norm(tekst).split(' ').filter(function(o){ return o.length > 1; });
    if (!ord.length) { visStart(); return; }

    sidsteOrd = ord.join(' ');
    erForside = !!erStart;
    henter = true;
    visHenter();

    var noegle = ord.slice().sort(function(a,b){ return b.length - a.length; })[0];

    try {
      var mod = await import(FS);
      var snap = await mod.getDocs(mod.query(
        mod.collection(window.firebaseDb, 'shopProducts'),
        mod.where('tokens', 'array-contains', noegle),
        mod.limit(MAKS)
      ));

      fundne = laesSnap(snap, ord);
      nulstilFiltre();
      vist = SIDE;
      await hentAlleSatser();
      sorter();
      byggFiltre();
      anvend();
    } catch (e) {
      console.error(e);
      var link = e.message && e.message.match(/https:\/\/[^\s]+/);
      visFejl(link ? link[0] : null);
    }
    henter = false;
  }

  function sorter(){
    var s = srtEl ? srtEl.value : 'cashback';
    fundne.sort(function(a,b){
      if (s === 'pris-op') return a.pris - b.pris;
      if (s === 'rabat') { if (b.rabat !== a.rabat) return b.rabat - a.rabat; return b.pris - a.pris; }
      /* Cashback kendes først, når butikkernes satser er hentet. Derfor
         sorteres der altid EFTER hentAlleSatser(), aldrig før. Varer
         uden kendt sats regnes som 0 og havner nederst. */
      if (s === 'cashback') {
        var ca = cashbackAf(a) || 0, cbb = cashbackAf(b) || 0;
        if (cbb !== ca) return cbb - ca;
        return b.pris - a.pris;
      }
      if (s === 'navn') {
        return String(a.title || '').localeCompare(String(b.title || ''), 'da');
      }
      return b.pris - a.pris;
    });
  }

  /* ---------- Filtrene ---------- */

  function nulstilFiltre(){
    filtre = { butik: [], maerke: [], farve: [], cashback: [],
               minPris: null, maxPris: null, kunTilbud: false };
    udvidet = {};
  }

  function farverAf(p){
    var t = p.tokens || [];
    var ud = [];
    for (var i = 0; i < FARVER.length; i++) {
      if (t.indexOf(FARVER[i]) > -1) ud.push(FARVER[i]);
    }
    return ud;
  }

  /* Cashback filtreres på satsen, samme tal som butikssiderne viser.
     Satsen hører til butikken, ikke til varen, så listen bliver kort.
     Butikker med et fast beløb har ingen procent og samles for sig —
     ellers ville deres varer være umulige at få frem. */
  function cbSatsAf(p){
    var s = satser[p.shopHandle];
    if (!s) return null;
    if (s.pct > 0) return String(s.pct);
    if (s.fast > 0) return 'fast';
    return null;
  }
  function cbSatsNavn(id){
    if (id === 'fast') return 'Fast beløb';
    return String(id).replace('.', ',') + '%';
  }

  function stort(s){
    s = String(s || '');
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }

  /* Tæller hvor mange varer der findes pr. værdi, så tallet kan stå på
     chippen. Værdier med kun ét træf er sjældent værd at filtrere på,
     men de bliver stående — det er billigere end at skjule noget,
     brugeren leder efter. */
  function taeller(vaerdier){
    var m = {};
    vaerdier.forEach(function(v){ if (v) m[v] = (m[v] || 0) + 1; });
    return Object.keys(m).map(function(k){ return { v: k, n: m[k] }; })
      .sort(function(a,b){ return b.n - a.n || a.v.localeCompare(b.v, 'da'); });
  }

  /* Én valgmulighed = én række med afkrydsningsfelt og antal. Rækker
     under hinanden skimmes hurtigere end chips i vilkårlig bredde. */
  function raekker(gruppe, liste, vis){
    var alle = udvidet[gruppe] === true;
    var del = alle ? liste : liste.slice(0, VIS_MAKS);
    var html = del.map(function(x){
      var valgt = filtre[gruppe].indexOf(x.v) > -1;
      return '<label class="mc-s__row' + (valgt ? ' er-valgt' : '') + '">' +
        '<input type="checkbox" data-f="' + gruppe + '" data-v="' + esc(x.v) + '"' +
          (valgt ? ' checked' : '') + '>' +
        '<span class="mc-s__box" aria-hidden="true"></span>' +
        '<span class="mc-s__row-t">' + esc(vis ? vis(x.v) : x.v) + '</span>' +
        '<span class="mc-s__row-n">' + x.n + '</span></label>';
    }).join('');
    if (liste.length > VIS_MAKS) {
      html += '<button type="button" class="mc-s__mere" data-mere="' + gruppe + '">' +
        (alle ? 'Vis færre' : 'Vis alle ' + liste.length) + '</button>';
    }
    return html;
  }

  /* Grupperne er <details>, så browseren selv klarer at folde ud og
     sammen. Ingen JavaScript, og det virker uden mus. */
  function gruppe(titel, indhold, aaben, antalValgt){
    return '<details class="mc-s__grp"' + (aaben ? ' open' : '') + '>' +
      '<summary class="mc-s__grp-h">' + esc(titel) +
      (antalValgt ? '<span class="mc-s__grp-n">' + antalValgt + '</span>' : '') +
      '</summary><div class="mc-s__grp-b">' + indhold + '</div></details>';
  }

  /* Grupperne bygges i alfabetisk rækkefølge (Butik, Cashback, Farve,
     Mærke, Pris, Tilbud), og starter alle lukkede — en gruppe folder
     kun sig selv ud, hvis der allerede er valgt noget i den (fx efter
     en søgning med filtre sat via URL, eller når "Ryd alle" ikke er
     brugt endnu). */
  function byggFiltre(){
    if (!fundne.length) { fPan.hidden = true; fPan.innerHTML = ''; fBtn.hidden = true; return; }

    var butikker = taeller(fundne.map(function(p){ return p.shopHandle; }));
    var maerker = taeller(fundne.map(function(p){ return String(p.brand || '').trim(); }));
    var farver = taeller([].concat.apply([], fundne.map(farverAf)));
    var tilbud = fundne.filter(function(p){ return p.rabat > 0; }).length;

    var priser = fundne.map(function(p){ return p.pris; });
    var lav = Math.floor(Math.min.apply(null, priser));
    var hoej = Math.ceil(Math.max.apply(null, priser));

    var h = '<div class="mc-s__side-top">' +
      '<p class="mc-s__side-h">Filtrér</p>' +
      '<button type="button" class="mc-s__ryd" id="mc-s-fryd">Ryd alle</button>' +
      '<button type="button" class="mc-s__luk-x" id="mc-s-lukx" aria-label="Luk filtre">✕</button></div>';

    /* ---- Butik ---- */
    if (butikker.length > 1) {
      h += gruppe('Butik', raekker('butik', butikker, butiksNavn), filtre.butik.length > 0, filtre.butik.length);
    }

    /* ---- Cashback ----
       Satserne står fra høj til lav — den højeste er den, folk leder
       efter. "Fast beløb" ligger til sidst, da den ikke kan rangeres
       sammen med procenterne. */
    var cbTael = {};
    fundne.forEach(function(p){
      var id = cbSatsAf(p);
      if (id) cbTael[id] = (cbTael[id] || 0) + 1;
    });
    var cbListe = Object.keys(cbTael).sort(function(a, b){
      if (a === 'fast') return 1;
      if (b === 'fast') return -1;
      return parseFloat(b) - parseFloat(a);
    }).map(function(k){ return { v: k, n: cbTael[k] }; });
    if (cbListe.length > 1) {
      h += gruppe('Cashback', raekker('cashback', cbListe, cbSatsNavn),
        filtre.cashback.length > 0, filtre.cashback.length);
    }

    /* ---- Farve ---- */
    if (farver.length > 1) {
      h += gruppe('Farve', raekker('farve', farver, stort), filtre.farve.length > 0, filtre.farve.length);
    }

    /* ---- Mærke ----
       Står tomt på mange feeds — gruppen vises kun hvis der er noget */
    if (maerker.length > 1) {
      h += gruppe('Mærke', raekker('maerke', maerker), filtre.maerke.length > 0, filtre.maerke.length);
    }

    /* ---- Pris ---- */
    h += gruppe('Pris',
      '<div class="mc-s__prisrow">' +
        '<input type="number" class="mc-s__pris" id="mc-s-min" inputmode="numeric" ' +
          'placeholder="' + lav + '" value="' + (filtre.minPris == null ? '' : filtre.minPris) +
          '" aria-label="Laveste pris">' +
        '<span class="mc-s__dash">–</span>' +
        '<input type="number" class="mc-s__pris" id="mc-s-maks" inputmode="numeric" ' +
          'placeholder="' + hoej + '" value="' + (filtre.maxPris == null ? '' : filtre.maxPris) +
          '" aria-label="Højeste pris">' +
      '</div><p class="mc-s__hint">Priser fra ' + lav.toLocaleString('da-DK') + ' til ' +
      hoej.toLocaleString('da-DK') + ' kr</p>',
      (filtre.minPris != null || filtre.maxPris != null), (filtre.minPris != null || filtre.maxPris != null) ? 1 : 0);

    /* ---- Tilbud ---- */
    if (tilbud > 0) {
      h += gruppe('Tilbud',
        '<label class="mc-s__row' + (filtre.kunTilbud ? ' er-valgt' : '') + '">' +
          '<input type="checkbox" data-t="kunTilbud"' + (filtre.kunTilbud ? ' checked' : '') + '>' +
          '<span class="mc-s__box" aria-hidden="true"></span>' +
          '<span class="mc-s__row-t">Kun varer på tilbud</span>' +
          '<span class="mc-s__row-n">' + tilbud + '</span></label>',
        filtre.kunTilbud, filtre.kunTilbud ? 1 : 0);
    }

    /* Kun synlig i skuffen på mobil */
    h += '<div class="mc-s__side-bund">' +
      '<button type="button" class="mc-s__luk" id="mc-s-fluk">Vis resultater</button></div>';

    fPan.innerHTML = h;
    fPan.hidden = false;
    fBtn.hidden = false;
  }

  function antalFiltre(){
    return filtre.butik.length + filtre.maerke.length +
      filtre.farve.length + filtre.cashback.length +
      (filtre.minPris != null ? 1 : 0) + (filtre.maxPris != null ? 1 : 0) +
      (filtre.kunTilbud ? 1 : 0);
  }

  function passer(p){
    if (filtre.minPris != null && p.pris < filtre.minPris) return false;
    if (filtre.maxPris != null && p.pris > filtre.maxPris) return false;
    if (filtre.kunTilbud && !(p.rabat > 0)) return false;
    if (filtre.cashback.length && filtre.cashback.indexOf(cbSatsAf(p)) === -1) return false;
    if (filtre.butik.length && filtre.butik.indexOf(p.shopHandle) === -1) return false;
    if (filtre.maerke.length && filtre.maerke.indexOf(String(p.brand || '').trim()) === -1) return false;
    if (filtre.farve.length) {
      var f = farverAf(p);
      var traf2 = filtre.farve.some(function(v){ return f.indexOf(v) > -1; });
      if (!traf2) return false;
    }
    return true;
  }

  /* Kører filtrene igennem og tegner forfra */
  function anvend(){
    synlige = fundne.filter(passer);
    vist = SIDE;
    var n = antalFiltre();
    fNum.textContent = n;
    fNum.classList.toggle('vis', n > 0);
    visValgte();
    tegn();
  }

  function visValgte(){
    var m = [];
    function tilfoej(gruppe, v, tekst){
      m.push('<span class="mc-s__vchip">' + esc(tekst) +
        '<button type="button" class="mc-s__vx" data-x="' + gruppe + '" data-v="' + esc(v) +
        '" aria-label="Fjern filter">✕</button></span>');
    }
    filtre.butik.forEach(function(v){ tilfoej('butik', v, butiksNavn(v)); });
    filtre.maerke.forEach(function(v){ tilfoej('maerke', v, v); });
    filtre.farve.forEach(function(v){ tilfoej('farve', v, stort(v)); });
    filtre.cashback.forEach(function(v){ tilfoej('cashback', v, cbSatsNavn(v)); });
    if (filtre.minPris != null) tilfoej('minPris', '', 'Fra ' + filtre.minPris + ' kr');
    if (filtre.maxPris != null) tilfoej('maxPris', '', 'Til ' + filtre.maxPris + ' kr');
    if (filtre.kunTilbud) tilfoej('kunTilbud', '', 'På tilbud');
    vElm.innerHTML = m.join('');
    vElm.hidden = !m.length;
  }

  /* ---------- Tegning ---------- */
  function kort(p, i){
    var cb = cashbackAf(p);
    /* Satsen som den står på butikssiden — "3%" eller "50 kr" */
    var s = satser[p.shopHandle] || {};
    var sats = s.fast > 0 ? Math.round(s.fast) + ' kr'
             : (s.pct > 0 ? String(s.pct).replace('.', ',') + '%' : '');
    /* Kan beløbet ikke beregnes — typisk fordi varen står uden pris —
       vises satsen i stedet. Bedre end en tom besked. */
    /* Butikssiderne viser satsen — "2,5%". Gør vi noget andet her,
       ser det ud som to forskellige tilbud. Satsen står derfor først,
       og det udregnede beløb i parentes. Faste beløb har ingen sats
       at vise, så de står alene. */
    var baandTekst = null;
    if (s.fast > 0) {
      baandTekst = Math.round(s.fast) + ' kr Cashback';
    } else if (s.pct > 0 && cb != null) {
      baandTekst = sats + ' Cashback (' + cb.toLocaleString('da-DK') + ' kr)';
    } else if (sats) {
      baandTekst = sats + ' Cashback';
    }
    var baand = baandTekst
      ? '<div class="mc-s__band">' + baandTekst + '</div>'
      : '<div class="mc-s__band mc-s__band--none">Cashback beregnes ved klik</div>';
    var foer = p.rabat >= 5
      ? '<span class="mc-s__was">' + p.foer.toLocaleString('da-DK') + ' kr</span>' : '';
    var mrk = p.rabat >= 25
      ? '<span class="mc-s__save">-' + p.rabat + '%</span>' : '';

    return '<div class="mc-s__card" data-i="' + i + '" role="button" tabindex="0" aria-label="' + esc(p.title) + '">' +
      '<div class="mc-s__media">' + mrk +
        '<button type="button" class="mc-s__gift" data-gift="' + i + '" aria-label="Gem på ønskeliste">+</button>' +
        '<img src="' + esc(p.image) + '" alt="" loading="lazy"></div>' +
      '<div class="mc-s__body">' +
        '<span class="mc-s__shop">' + esc(butiksNavn(p.shopHandle)) + '</span>' +
        '<h3 class="mc-s__name">' + esc(p.title) + '</h3>' +
        '<div class="mc-s__price"><span class="mc-s__now">' +
          p.pris.toLocaleString('da-DK') + ' kr</span>' + foer + '</div>' +
      '</div>' + baand + '</div>';
  }

    /* ---------- Forsidens udvalg = én bestemt butiks varer ----------
     Vises i gitteret, før der er søgt — med præcis samme kort, filtre
     og sortering som et rigtigt søgeresultat. Det er ikke et separat
     "butiks-kort", men en almindelig forespørgsel i shopProducts,
     bare med shopHandle i stedet for et søgeord. Søgefeltet forbliver
     tomt, så det er tydeligt at intet er søgt endnu. */
  var STANDARD_SHOP = 'yuaia';
  async function hentStandardVarer(){
    if (!window.firebaseDb) return;
    henter = true;
    visHenter();
    try {
      var mod = await import(FS);
      var snap = await mod.getDocs(mod.query(
        mod.collection(window.firebaseDb, 'shopProducts'),
        mod.where('shopHandle', '==', STANDARD_SHOP),
        mod.limit(MAKS)
      ));
      fundne = laesSnap(snap);
      erForside = true;
      nulstilFiltre();
      vist = SIDE;
      await hentAlleSatser();
      sorter();
      byggFiltre();
      anvend();
    } catch (e) {
      console.error(e);
      var link = e.message && e.message.match(/https:\/\/[^\s]+/);
      visFejl(link ? link[0] : null);
    }
    henter = false;
  }

  function tegn(){
    msgEl.hidden = true;
    if (!synlige.length){
      grid.innerHTML = '';
      msgEl.hidden = false;
      if (fundne.length && antalFiltre() > 0) {
        msgEl.innerHTML = '<p class="mc-s__msg-t">Ingen varer matcher filtrene</p>' +
          '<p class="mc-s__msg-p">Der er ' + fundne.length + ' varer i søgningen, men ingen af dem ' +
          'passer på alle de valgte filtre. Fjern et filter for at se flere.</p>';
      } else if (erForside) {
        msgEl.innerHTML = '<p class="mc-s__msg-t">Ingen varer at vise lige nu</p>' +
          '<p class="mc-s__msg-p">Butikkens udvalg gav ingen varer lige nu. ' +
          'Søg efter noget andet i feltet ovenfor.</p>';
      } else {
        msgEl.innerHTML = '<p class="mc-s__msg-t">Ingen varer matchede "' + esc(sidsteOrd) + '"</p>' +
          '<p class="mc-s__msg-p">Prøv et enkelt ord i stedet for flere, eller et bredere ord. ' +
          'Søgningen matcher hele ord — "sofabord" finder ikke "sofaborde".</p>';
      }
      cntEl.textContent = '';
      morW.hidden = true;
      dscEl.hidden = true;
      return;
    }
    grid.innerHTML = synlige.slice(0, vist).map(kort).join('');
    markerIkoner();
    var butikker = new Set(synlige.map(function(p){ return p.shopHandle; })).size;
    var haleTal = (!antalFiltre() && fundne.length >= MAKS) ? '+' : '';
    cntEl.innerHTML = 'Viser <b>' + Math.min(vist, synlige.length) + '</b> af <b>' +
      synlige.length + haleTal + '</b> varer fra <b>' + butikker + '</b> butikker' +
      (antalFiltre() ? ' <span style="opacity:.7">(filtreret fra ' + fundne.length + ')</span>' : '');
    morW.hidden = vist >= synlige.length;
    dscEl.hidden = false;
    dscEl.textContent = 'Priser og lagerstatus kommer fra butikkernes egne produktfeeds og kan ' +
      'være ændret. Cashbacken beregnes af varens pris og udbetales, når butikken har godkendt købet.';
  }

  function visHenter(){
    grid.innerHTML = '';
    grid.classList.remove('mc-s__grid--shops');
    if (srtEl) srtEl.hidden = false;
    morW.hidden = true;
    dscEl.hidden = true;
    cntEl.textContent = '';
    fBtn.hidden = true;
    fPan.hidden = true;
    vElm.hidden = true;
    msgEl.hidden = false;
    msgEl.innerHTML = '<div class="mc-s__spin"></div><p class="mc-s__msg-p">Søger i alle butikker…</p>';
  }

  /* Feltet er tomt: siden nulstilles. Startudvalget hentes kun, når
     man kommer ind på siden — rydder man selv feltet, er det fordi man
     vil skrive noget andet. */
  function visStart(){
    grid.innerHTML = '';
    fundne = [];
    synlige = [];
    erForside = false;
    sidsteOrd = '';
    nulstilFiltre();
    fPan.innerHTML = '';
    fPan.hidden = true;
    fBtn.hidden = true;
    fBtn.setAttribute('aria-expanded', 'false');
    vElm.hidden = true;
    morW.hidden = true;
    dscEl.hidden = true;
    cntEl.textContent = '';
    hentStandardVarer();
  }

  function visFejl(indexLink){
    grid.innerHTML = '';
    morW.hidden = true;
    fBtn.hidden = true;
    fPan.hidden = true;
    vElm.hidden = true;
    msgEl.hidden = false;
    msgEl.innerHTML = '<p class="mc-s__msg-t">Søgningen kunne ikke gennemføres</p>' +
      '<p class="mc-s__msg-p">' + (indexLink
        ? 'Der mangler et Firestore-index. <a href="' + esc(indexLink) + '" target="_blank" rel="noopener" style="color:#A97900;font-weight:800;">Klik her for at oprette det →</a>'
        : 'Prøv igen om et øjeblik.') + '</p>';
  }

  /* ---------- Ønskelisten ---------- */
  var STDLISTE = 'Min Ønskeliste';
  var TYPE_EMOJI = { wishlist:'🎁', planned:'🛒', project:'🏠', christmas:'🎄', birthday:'🎂' };
  var gemte = {};    /* ren produkt-url -> { id, liste } */
  var lister = null; /* hentes første gang der klikkes */

  /* Varens rene adresse hos butikken, trukket ud af deeplinkets
     destinationsparameter. Uden det ville ønskelisten gemme et
     affiliate-link med sporings-id'er, der udløber. */
  function renUrl(deeplink){
    var s = String(deeplink || '');
    var m = s.match(/[?&](?:htmlurl|url|dl|redirect)=(.+)$/i);
    if (!m) return s;
    var u = m[1];
    if (u.indexOf('%') > -1) { try { u = decodeURIComponent(u); } catch (e) {} }
    return /^https?:\/\//i.test(u) ? u : s;
  }
  function domaene(u){
    try { return new URL(u).hostname.replace(/^www\./,''); } catch (e) { return ''; }
  }
  /* Vi har kun butikkens handle i varen, ikke dens pæne navn. Første
     bogstav gøres stort, så "knivsalg" bliver til "Knivsalg". */
  function butiksNavn(h){
    var s = String(h || '');
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }

  var toastEl = null;
  function toast(besked){
    if (!toastEl){
      toastEl = document.createElement('div');
      toastEl.className = 'mc-s-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = besked;
    toastEl.classList.add('vis');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function(){ toastEl.classList.remove('vis'); }, 2600);
  }

  function markerIkoner(){
    grid.querySelectorAll('.mc-s__gift').forEach(function(b){
      var p = synlige[Number(b.dataset.gift)];
      if (!p) return;
      var g = gemte[renUrl(p.deeplink)];
      b.dataset.saved = g ? 'true' : 'false';
      b.textContent = g ? '✓' : '+';
      b.title = g ? 'Fjern fra "' + g.liste + '"' : 'Gem på ønskeliste';
    });
  }

  function aabnAuth(tab){
    var m = document.getElementById('mc3-auth-modal');
    if (m){
      m.style.display = 'flex';
      if (typeof window.switchAuthTab === 'function') window.switchAuthTab(tab);
    }
  }

  async function hentGemte(uid){
    try {
      var mod = await import(FS);
      var snap = await mod.getDocs(mod.query(
        mod.collection(window.firebaseDb, 'wishlists'),
        mod.where('userId', '==', uid)
      ));
      gemte = {};
      snap.forEach(function(d){
        var w = d.data();
        if (w.productUrl) gemte[w.productUrl] = { id: d.id, liste: w.listName || STDLISTE };
      });
      markerIkoner();
    } catch (e) { console.log('Ønskelisten kunne ikke læses:', e); }
  }

  async function hentLister(uid){
    if (lister) return lister;
    var mod = await import(FS);
    var db = window.firebaseDb;
    var snap;
    try {
      snap = await mod.getDocs(mod.query(
        mod.collection(db, 'available_lists'),
        mod.where('userId', '==', uid),
        mod.orderBy('order', 'asc')
      ));
    } catch (e) {
      /* Mangler det sammensatte indeks, klarer vi os uden sortering */
      snap = await mod.getDocs(mod.query(
        mod.collection(db, 'available_lists'),
        mod.where('userId', '==', uid)
      ));
    }
    lister = [];
    snap.forEach(function(d){
      var l = d.data();
      lister.push({ id: d.id, name: l.name, type: l.type || 'wishlist', order: l.order });
    });
    lister.sort(function(a,b){ return (a.order||0) - (b.order||0); });
    return lister;
  }

  async function gemPaaListe(p, listeNavn, btn){
    var user = window.firebaseAuth && window.firebaseAuth.currentUser;
    if (!user){ aabnAuth('signup'); return; }
    if (btn) btn.disabled = true;
    var ren = renUrl(p.deeplink);
    var s = satser[p.shopHandle] || {};
    try {
      var mod = await import(FS);
      /* storeName = varens navn og productTitle = butikkens navn.
         Det ser byttet om ud, men ønskelistens kort viser productTitle
         som lille label og storeName som overskrift. */
      var ref = await mod.addDoc(mod.collection(window.firebaseDb, 'wishlists'), {
        userId: user.uid,
        listName: listeNavn,
        productUrl: ren,
        productTitle: butiksNavn(p.shopHandle),
        storeName: p.title,
        shopHandle: p.shopHandle || null,
        domain: domaene(ren) || domaene(p.deeplink),
        productImage: p.image || null,
        price: p.pris || null,
        cashbackRate: s.pct > 0 ? s.pct : null,
        cashbackFast: s.fast > 0 ? s.fast : null,
        /* Stemplet holder mcEfterfyldPartnere() væk. Uden det ville
           den overskrive varens navn og billede med butikkens logo. */
        cashbackVersion: 2,
        isPartner: true,
        priority: 'none',
        bought: false,
        link: p.deeplink || null,
        timestamp: mod.serverTimestamp()
      });
      gemte[ren] = { id: ref.id, liste: listeNavn };
      markerIkoner();
      toast('Gemt i "' + listeNavn + '"');
    } catch (e) {
      console.error('Ønsket kunne ikke gemmes:', e);
      toast('Ønsket kunne ikke gemmes. Prøv igen.');
    }
    if (btn) btn.disabled = false;
  }

  async function fjernOenske(p, btn){
    var ren = renUrl(p.deeplink);
    var g = gemte[ren];
    if (!g) return;
    if (btn) btn.disabled = true;
    try {
      var mod = await import(FS);
      await mod.deleteDoc(mod.doc(window.firebaseDb, 'wishlists', g.id));
      delete gemte[ren];
      markerIkoner();
      toast('Fjernet fra "' + g.liste + '"');
    } catch (e) {
      console.error('Ønsket kunne ikke fjernes:', e);
      toast('Ønsket kunne ikke fjernes. Prøv igen.');
    }
    if (btn) btn.disabled = false;
  }

  /* ---------- Listevælgeren ---------- */
  var pop = null;
  function lukPop(){ if (pop){ pop.classList.remove('vis'); pop.hidden = true; } }
  function byggePop(){
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'mc-s-pop';
    pop.hidden = true;
    document.body.appendChild(pop);
    document.addEventListener('click', function(e){
      if (pop.hidden) return;
      if (!pop.contains(e.target) && !e.target.closest('.mc-s__gift')) lukPop();
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') lukPop(); });
    window.addEventListener('scroll', lukPop, { passive: true });
    window.addEventListener('resize', lukPop);
    return pop;
  }
  function placerPop(btn){
    var r = btn.getBoundingClientRect();
    pop.hidden = false;
    var b = pop.getBoundingClientRect();
    var top = r.bottom + 8;
    if (top + b.height > window.innerHeight - 12) top = Math.max(12, r.top - b.height - 8);
    pop.style.left = Math.max(12, Math.min(r.right - b.width, window.innerWidth - b.width - 12)) + 'px';
    pop.style.top = top + 'px';
    void pop.offsetWidth;
    pop.classList.add('vis');
  }

  async function visVaelger(p, btn){
    var user = window.firebaseAuth && window.firebaseAuth.currentUser;
    if (!user){ aabnAuth('signup'); return; }

    byggePop();
    pop.innerHTML = '<p class="mc-s-pop__h">Gem på ønskeliste</p><p class="mc-s-pop__tom">Henter dine lister…</p>';
    placerPop(btn);

    var l = [];
    try { l = await hentLister(user.uid); }
    catch (e) { console.log('Listerne kunne ikke hentes:', e); }

    /* Har brugeren ingen lister endnu, gemmer vi i standardlisten.
       Den oprettes af ensureStarterLists(), første gang ønskelistesiden
       åbnes, og ønsket dukker op der. */
    if (!l.length){ lukPop(); await gemPaaListe(p, STDLISTE, btn); return; }
    if (l.length === 1){ lukPop(); await gemPaaListe(p, l[0].name, btn); return; }

    pop.innerHTML = '<p class="mc-s-pop__h">Gem på ønskeliste</p>' + l.map(function(x,n){
      return '<button type="button" class="mc-s-pop__row" data-liste="' + n + '">' +
        '<span class="mc-s-pop__emoji" aria-hidden="true">' + (TYPE_EMOJI[x.type] || '🎁') + '</span>' +
        '<span>' + esc(x.name) + '</span></button>';
    }).join('');
    placerPop(btn);

    pop.querySelectorAll('.mc-s-pop__row').forEach(function(row){
      row.addEventListener('click', function(){
        var valgt = l[Number(row.dataset.liste)];
        lukPop();
        gemPaaListe(p, valgt.name, btn);
      });
    });
  }

  /* ---------- Klik videre til butikken ----------
     Netværket genkendes på linkets parametre, ikke på domænet — samme
     regler som "Aktiver cashback"-knappen på butikssiden. */
  function sporingsFelt(base){
    var u = String(base).toLowerCase();
    if (u.indexOf('partnerid=') > -1 && u.indexOf('bannerid=') > -1) return 'uid';
    if (u.indexOf('awinmid=') > -1 && u.indexOf('awinaffid=') > -1) return 'clickref';
    if (/[?&]si=/.test(u) && /[?&]li=/.test(u) && /[?&]wi=/.test(u)) return 'ws';
    if (/[?&]c=\d/.test(u) && /[?&]m=\d/.test(u) && /[?&]a=\d/.test(u)) return 'r';
    if (/[?&]p=\d/.test(u) && /[?&]a=\d/.test(u)) return 'epi';
    if (/[?&]t=\d/.test(u) && /[?&]tt=/.test(u)) return 'epi';
    if (u.indexOf('adtraction') > -1) return 'epi';
    if (u.indexOf('tradetracker') > -1) return 'r';
    if (u.indexOf('adservice') > -1) return 'ext_id';
    if (u.indexOf('awin') > -1 || u.indexOf('zenaps') > -1) return 'clickref';
    if (u.indexOf('partner-ads.com') > -1) return 'uid';
    if (u.indexOf('tradedoubler') > -1) return 'epi';
    if (u.indexOf('daisycon') > -1) return 'ws';
    return 'uid';
  }

  function medSporing(base, uid){
    var navn = sporingsFelt(base);
    var vaerdi = encodeURIComponent(String(uid).replace(/['"#]/g,'').slice(0,240));
    var findes = new RegExp('([?&])' + navn + '=([^&]*)');
    var fund = base.match(findes);
    if (fund) return base.replace(findes, '$1' + navn + '=' + (fund[2] ? fund[2] + '__' + vaerdi : vaerdi));
    /* Feltet skal ind FØR destinationsadressen. Alt efter url=, htmlurl=
       og dl= opfatter netværket som en del af butikkens egen adresse. */
    var pos = -1;
    ['&url=','?url=','&htmlurl=','?htmlurl=','&dl=','?dl='].forEach(function(m){
      var q = base.indexOf(m);
      if (q > -1 && (pos === -1 || q < pos)) pos = q;
    });
    if (pos > -1) return base.slice(0,pos) + '&' + navn + '=' + vaerdi + base.slice(pos);
    return base + (base.indexOf('?') > -1 ? '&' : '?') + navn + '=' + vaerdi;
  }

  function aabnVare(p){
    if (!p || !p.deeplink) return;
    var user = window.firebaseAuth && window.firebaseAuth.currentUser;
    if (!user){
      var modal = document.getElementById('mc3-auth-modal');
      if (modal){
        modal.style.display = 'flex';
        if (typeof window.switchAuthTab === 'function') window.switchAuthTab('signup');
      }
      return;
    }
    /* Påmindelsen ligger i snippets/mincashback-husk.liquid og vises
       kun første gang i en session. Findes den ikke, går vi direkte. */
    if (window.mcHuskKlik) window.mcHuskKlik(butiksNavn(p.shopHandle), function(){ gaaTilVare(p, user); });
    else gaaTilVare(p, user);
  }

  async function gaaTilVare(p, user){
    /* Fanen åbnes straks, mens browserens klik-tilladelse gælder.
       Venter vi på Firestore, blokerer Safari vinduet. */
    var vindue = window.open('', '_blank');
    var url = medSporing(p.deeplink, user.uid);
    if (vindue) vindue.location.href = url; else window.location.href = url;

    try {
      var mod = await import(FS);
      await mod.addDoc(mod.collection(window.firebaseDb, 'clicks'), {
        userId: user.uid, type: 'soegning', butikHandle: p.shopHandle || '',
        vareId: p.id, vareNavn: p.title, varePris: p.pris,
        soegeord: sidsteOrd, url: url, dato: mod.serverTimestamp()
      });
    } catch (e) { console.log('Klik ikke gemt:', e); }
  }

  /* ---------- Hændelser ---------- */
  grid.addEventListener('click', function(e){
    var gift = e.target.closest('.mc-s__gift');
    if (gift){
      e.preventDefault();
      e.stopPropagation();
      var g = synlige[Number(gift.dataset.gift)];
      if (!g) return;
      if (gemte[renUrl(g.deeplink)]) fjernOenske(g, gift);
      else visVaelger(g, gift);
      return;
    }
    var k = e.target.closest('.mc-s__card');
    if (k && k.dataset.i !== undefined) aabnVare(synlige[Number(k.dataset.i)]);
  });
  grid.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var k = e.target.closest('.mc-s__card');
    if (!k || k.dataset.i === undefined) return;
    e.preventDefault();
    aabnVare(synlige[Number(k.dataset.i)]);
  });

  /* Filterknappen åbner skuffen. Den vises kun på mobil — på store
     skærme står spalten fast og skal ikke kunne lukkes væk. */
  function skuffe(aaben){
    fPan.classList.toggle('er-aaben', aaben);
    if (skygge) skygge.hidden = !aaben;
    fBtn.setAttribute('aria-expanded', aaben ? 'true' : 'false');
    document.body.style.overflow = aaben ? 'hidden' : '';
  }
  fBtn.addEventListener('click', function(){ skuffe(!fPan.classList.contains('er-aaben')); });
  if (skygge) skygge.addEventListener('click', function(){ skuffe(false); });

  /* Afkrydsningsfelterne */
  fPan.addEventListener('change', function(e){
    var i = e.target;
    if (!i || i.type !== 'checkbox') return;
    var raekke = i.closest('.mc-s__row');
    if (i.dataset.f){
      var g = i.dataset.f, v = i.dataset.v;
      var n = filtre[g].indexOf(v);
      if (n > -1) filtre[g].splice(n, 1); else filtre[g].push(v);
    } else if (i.dataset.t){
      filtre[i.dataset.t] = i.checked;
    } else return;
    if (raekke) raekke.classList.toggle('er-valgt', i.checked);
    anvend();
  });

  /* Knapperne i spalten */
  fPan.addEventListener('click', function(e){
    var mere = e.target.closest('[data-mere]');
    if (mere){
      var mg = mere.dataset.mere;
      udvidet[mg] = !udvidet[mg];
      byggFiltre();
      return;
    }
    if (e.target.closest('#mc-s-fryd')){
      nulstilFiltre();
      byggFiltre();
      anvend();
      return;
    }
    if (e.target.closest('#mc-s-fluk') || e.target.closest('#mc-s-lukx')){
      skuffe(false);
      return;
    }
  });

  /* Prisfelterne reagerer på indtastning med en lille forsinkelse, så
     der ikke tegnes forfra for hvert tastetryk. */
  var prisTimer = null;
  fPan.addEventListener('input', function(e){
    if (!e.target.classList.contains('mc-s__pris')) return;
    clearTimeout(prisTimer);
    prisTimer = setTimeout(function(){
      var mn = document.getElementById('mc-s-min');
      var mx = document.getElementById('mc-s-maks');
      var a = mn && mn.value !== '' ? Number(mn.value) : null;
      var b = mx && mx.value !== '' ? Number(mx.value) : null;
      filtre.minPris = (a != null && !isNaN(a)) ? a : null;
      filtre.maxPris = (b != null && !isNaN(b)) ? b : null;
      anvend();
    }, 400);
  });

  /* Mærkaterne over gitteret fjerner ét filter ad gangen */
  vElm.addEventListener('click', function(e){
    var x = e.target.closest('[data-x]');
    if (!x) return;
    var g = x.dataset.x, v = x.dataset.v;
    if (g === 'minPris' || g === 'maxPris') filtre[g] = null;
    else if (g === 'kunTilbud') filtre[g] = false;
    else {
      var i = filtre[g].indexOf(v);
      if (i > -1) filtre[g].splice(i, 1);
    }
    byggFiltre();
    anvend();
  });

  /* ---------- Forslag i søgefeltet ----------
     Historikken ligger i browseren, ikke i databasen — den er kun
     til for den enkelte bruger og skal ikke koste et opslag. */
  function hentHistorik(){
    try {
      var l = JSON.parse(localStorage.getItem(HISTORIK_KEY));
      return Array.isArray(l) ? l.filter(function(x){ return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }

  function gemHistorik(ord){
    ord = String(ord || '').trim();
    if (!ord) return;
    try {
      var l = hentHistorik().filter(function(x){ return x.toLowerCase() !== ord.toLowerCase(); });
      l.unshift(ord);
      localStorage.setItem(HISTORIK_KEY, JSON.stringify(l.slice(0, HISTORIK_N)));
    } catch (e) {}
  }

  function autoRaekke(ord, ikon){
    return '<button type="button" class="mc-s__auto-r" data-ord="' + esc(ord) + '" role="option">' +
      '<span class="mc-s__auto-i" aria-hidden="true">' + ikon + '</span>' +
      '<span>' + esc(ord) + '</span></button>';
  }

  function lukAuto(){ if (autoEl) autoEl.hidden = true; }

  /* Historik + faste forslag, som før — bruges både når feltet er tomt,
     og som fallback hvis en live-søgning ikke giver nogen butikker
     eller varer. */
  function visAutoLokalHtml(raaTekst){
    var skrevet = norm(raaTekst);
    var hist = hentHistorik();
    var forslag = FORSLAG.slice();

    if (skrevet) {
      var passer = function(o){ return norm(o).indexOf(skrevet) > -1 && norm(o) !== skrevet; };
      hist = hist.filter(passer);
      forslag = forslag.filter(passer);
    }
    forslag = forslag.filter(function(o){
      return !hist.some(function(h){ return norm(h) === norm(o); });
    }).slice(0, 6);

    var h = '';
    if (hist.length) {
      h += '<p class="mc-s__auto-h">Senest søgt<button type="button" data-ryd>Ryd</button></p>' +
        hist.map(function(o){ return autoRaekke(o, '↺'); }).join('');
    }
    if (forslag.length) {
      h += '<p class="mc-s__auto-h">Forslag</p>' +
        forslag.map(function(o){ return autoRaekke(o, '⌕'); }).join('');
    }
    return h;
  }

  /* Butikker — samme Predictive Search-kald som header-søgefeltet
     bruger. Shopifys almindelige produktkatalog ER butikkerne, så
     resource-typen "product" giver kun butikker, ikke de 1 mio. varer
     (dem ligger udelukkende i Firestore). */
  async function hentButikForslag(query){
    try {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=5&resources[options][fields]=title';
      var r = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!r.ok) return [];
      var data = await r.json();
      var liste = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      return liste.map(function(p){
        return { title: p.title, url: p.url, image: (p.featured_image && p.featured_image.url) || p.image || '' };
      });
    } catch (e) { return []; }
  }

  /* Et par vare-eksempler fra Firestore — samme opslag som den fulde
     søgning bruger, bare begrænset til fire resultater. */
  async function hentVareForslag(query){
    var ord = norm(query).split(' ').filter(function(o){ return o.length > 1; });
    if (!ord.length) return [];
    var noegle = ord.slice().sort(function(a,b){ return b.length - a.length; })[0];
    try {
      var mod = await import(FS);
      var snap = await mod.getDocs(mod.query(
        mod.collection(window.firebaseDb, 'shopProducts'),
        mod.where('tokens', 'array-contains', noegle),
        mod.limit(20)
      ));
      var ud = [];
      snap.forEach(function(d){
        if (ud.length >= 4) return;
        var x = d.data();
        var t = x.tokens || [];
        for (var i = 0; i < ord.length; i++) { if (t.indexOf(ord[i]) === -1) return; }
        if (!x.image || !(Number(x.price) > 0)) return;
        ud.push({ title: x.title || '', image: x.image, pris: Number(x.price) || 0 });
      });
      return ud;
    } catch (e) { return []; }
  }

  function autoButikRaekke(p){
    return '<a class="mc-s__auto-r mc-s__auto-r--shop" href="' + esc(p.url) + '" role="option">' +
      (p.image ? '<img class="mc-s__auto-img" src="' + esc(p.image) + '" alt="" loading="lazy">'
               : '<span class="mc-s__auto-i" aria-hidden="true">🏬</span>') +
      '<span>' + esc(p.title) + '</span></a>';
  }

  var autoReqId = 0;

  async function visAutoLive(raaTekst){
    var minReq = ++autoReqId;
    var query = raaTekst.trim();
    var soegUrl = '/pages/soeg-varer?q=' + encodeURIComponent(query);

    var svar = await Promise.all([hentButikForslag(query), hentVareForslag(query)]);
    if (minReq !== autoReqId) return;                 /* et nyere kald er i gang */
    if (norm(qEl.value) !== norm(raaTekst)) return;    /* feltet er ændret siden */

    var butikker = svar[0], varer = svar[1];
    var h = '';
    if (butikker.length) {
      h += '<p class="mc-s__auto-h">Butikker</p>' + butikker.map(autoButikRaekke).join('');
    }
    if (varer.length) {
      h += '<p class="mc-s__auto-h">Varer</p>' + varer.map(function(v){
        return '<a class="mc-s__auto-r mc-s__auto-r--vare" href="' + soegUrl + '" role="option">' +
          '<img class="mc-s__auto-img" src="' + esc(v.image) + '" alt="" loading="lazy">' +
          '<span>' + esc(v.title) + ' — ' + v.pris.toLocaleString('da-DK') + ' kr</span></a>';
      }).join('');
    }

    if (!butikker.length && !varer.length) {
      h = visAutoLokalHtml(query);
      if (!h) { lukAuto(); return; }
    } else {
      h += '<a class="mc-s__auto-footer" href="' + soegUrl + '">Se alle varer for "' + esc(query) + '" →</a>';
    }
    autoEl.innerHTML = h;
    autoEl.hidden = false;
  }

  var autoTimer = null;

  /* Tomt felt: historik + forslag, med det samme. Skrevet felt: butikker
     og varer hentet live, med en lille forsinkelse så det ikke fyrer af
     for hvert tastetryk. */
  function visAuto(){
    if (!autoEl) return;
    var raa = qEl.value;

    if (!norm(raa)) {
      clearTimeout(autoTimer);
      var h = visAutoLokalHtml(raa);
      if (!h) { lukAuto(); return; }
      autoEl.innerHTML = h;
      autoEl.hidden = false;
      return;
    }

    clearTimeout(autoTimer);
    autoTimer = setTimeout(function(){ visAutoLive(raa); }, 260);
  }

  if (autoEl) {
    qEl.addEventListener('focus', visAuto);
    autoEl.addEventListener('click', function(e){
      if (e.target.closest('[data-ryd]')) {
        try { localStorage.removeItem(HISTORIK_KEY); } catch (err) {}
        visAuto();
        qEl.focus();
        return;
      }
      var r = e.target.closest('[data-ord]');
      if (!r) return;
      qEl.value = r.dataset.ord;
      clrEl.classList.add('vis');
      lukAuto();
      start();
    });
    document.addEventListener('click', function(e){
      if (!e.target.closest('.mc-s__field')) lukAuto();
    });
    qEl.addEventListener('keydown', function(e){ if (e.key === 'Escape') lukAuto(); });
  }

  var logBtn = document.getElementById('mc-s-login-b');
  if (logBtn) logBtn.addEventListener('click', function(){ aabnAuth('signup'); });

  function start(){
    var v = qEl.value.trim();
    if (!v) { visStart(); return; }
    /* Søgeordet lægges i adressen, så resultatet kan deles og
       browserens tilbageknap virker */
    try { history.replaceState(null, '', '?q=' + encodeURIComponent(v)); } catch (e) {}
    gemHistorik(v);
    lukAuto();
    soeg(v);
  }

  goEl.addEventListener('click', start);
  qEl.addEventListener('keydown', function(e){ if (e.key === 'Enter') start(); });
  qEl.addEventListener('input', function(){
    clrEl.classList.toggle('vis', !!qEl.value);
    visAuto();
  });
  clrEl.addEventListener('click', function(){
    qEl.value = '';
    clrEl.classList.remove('vis');
    qEl.focus();
    visAuto();
    visStart();
    try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
  });

  srtEl.addEventListener('change', function(){
    if (!fundne.length) return;
    sorter();
    anvend();
  });

  morEl.addEventListener('click', function(){
    vist += SIDE;
    tegn();
  });

  /* Firebase skal være klar, før der kan søges */
  var ventet = 0;
  var vent = setInterval(function(){
    ventet += 200;
    if (window.firebaseDb){
      clearInterval(vent);
      if (window.firebaseAuth){
        window.firebaseAuth.onAuthStateChanged(function(user){
          if (logEl) logEl.hidden = !!user;
          if (user) hentGemte(user.uid);
          else { gemte = {}; lister = null; markerIkoner(); }
        });
      }
      var fra = new URLSearchParams(window.location.search).get('q');
      if (fra){ qEl.value = fra; clrEl.classList.add('vis'); soeg(fra); }
      else visStart();
    } else if (ventet > 8000){
      clearInterval(vent);
      visFejl(null);
    }
  }, 200);
})();